import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";

import {gpCommon} from "../GasPass";

import icon_menu from "../static/icons/icon_menu.svg";
import icon_no_client_image from "../static/icons/icon_no_client_image.svg";


const ControllerMenu = ({ menu, navigation, data, serviceName, requireUrl }) => {

    const [visible, setVisible] = useState( false );

    if( visible && !gpCommon.getObject( menu, null ) ) {
        setVisible( false );
    }

    return(
        <div className={visible ? 'menuVisible' : undefined}>
            <div className="top">
                <div>
                    {gpCommon.getObject( menu, null ) !== null && <div className="switcher" onClick={onClickSwitchVisible}><img src={icon_menu} /></div>}
                    <div>{( data !== null ) ? gpCommon.getString( data['title'], serviceName ) : serviceName}</div>
                </div>
            </div>

            {gpCommon.getArray( navigation, null ) !== null && <div className="navigation">
                {gpCommon.getArray( navigation, [] ).map( ( item, index ) => {
                    if( gpCommon.getString( item['url'], null ) !== null ) {
                        return(
                            <a key={gpCommon.getString( item['id'], '' )} href={'/' + gpCommon.getString( item['url'], '' )} onClick={( e ) => onClickItem( e, gpCommon.getString( item['url'], '' ) )}>{gpCommon.getString( item['value'], '' )}</a>
                        );
                    }
                    else {
                        return(
                            <div key={gpCommon.getString( item['id'], '' )}>{gpCommon.getString( item['value'], '' )}</div>
                        );
                    }
                })}
            </div>}

            {gpCommon.getObject( menu, null ) !== null && <div className="menuContainer" onClick={onClickSwitchInvisible}>
                <div className="menu">
                    <div>
                        {gpCommon.getArray( menu, [] ).map( ( item ) => {
                            let itemType = gpCommon.getString( item['type'], null );
                            if( itemType !== null ) {
                                if( itemType === 'client' ) {
                                    // Информация о вошедшем клиенте
                                    return(
                                        <div key={gpCommon.getString( item['id'], '' )} className="client">
                                            <img src={icon_no_client_image} />
                                            <div>
                                                {gpCommon.getString( item['value'], null )}
                                                {gpCommon.getString( item['description'], null ) !== null && <br />}
                                                {gpCommon.getString( item['description'], null ) !== null && <span>{gpCommon.getString( item['description'], '' )}</span>}
                                            </div>
                                        </div>
                                    );
                                }
                                else if( itemType === 'item' ) {
                                    return(
                                        <a key={gpCommon.getString( item['id'], '' )} href={'/' + gpCommon.getString( item['url'], '' )} onClick={( e ) => onClickItem( e, gpCommon.getString( item['url'], '' ) )}>{gpCommon.getString( item['value'], '' )}</a>
                                    );
                                }
                                else if( itemType === 'separator' ) {
                                    return (
                                        <div key={gpCommon.getString( item['id'], '' )} className="separator"></div>
                                    );
                                }
                            }
                            return null;
                        })}
                    </div>
                </div>
            </div>}
        </div>
    );

    function onClickItem( e, url ) {
        e.preventDefault();
        requireUrl( url, {}, () => {
            setVisible( false );
        } );
    }

    function onClickSwitchVisible( e ) {
        if( !visible ) {
            setVisible( true );
        }
    }

    function onClickSwitchInvisible( e ) {
        if( e.target.classList.contains( 'menuContainer' ) && visible ) {
            setVisible( false );
        }
    }

}
ControllerMenu.propTypes = {
    menu: PropTypes.array,
    navigation: PropTypes.array,
    data: PropTypes.object,
    serviceName: PropTypes.string,
    requireUrl: PropTypes.func.isRequired
};
export default ControllerMenu;
